import React from "react";

export default class None extends React.Component {
    render() {
        return <div className="full-height"></div>;
    }
}
